import I18n from 'I18n';
export const getRelativeDateValueForProperty = (propertyExtensionsMetadata, propertyName) => {
  var _propertyExtensionsMe;
  if (propertyExtensionsMetadata && Object.prototype.hasOwnProperty.call(propertyExtensionsMetadata, propertyName) && ((_propertyExtensionsMe = propertyExtensionsMetadata[propertyName]) === null || _propertyExtensionsMe === void 0 || (_propertyExtensionsMe = _propertyExtensionsMe.metadata) === null || _propertyExtensionsMe === void 0 || (_propertyExtensionsMe = _propertyExtensionsMe.showRelativeDateValue) === null || _propertyExtensionsMe === void 0 ? void 0 : _propertyExtensionsMe.value) === 'dateWithRelativeTime') {
    return 'dateWithRelativeTime';
  }
  return 'dateOnly';
};
export const getRelativeDateTimeValue = ({
  value,
  isDate
}) => {
  if (!value) {
    return null;
  }
  const numberValue = Number(value);
  if (isNaN(numberValue)) {
    return null;
  }

  // CRMPropertyDateInput stores the timestamp of midnight UTC (toMoment function) for date properties
  const momentDay = I18n.moment.utc(numberValue).date();
  const momentMonth = I18n.moment.utc(numberValue).month();
  const momentYear = I18n.moment.utc(numberValue).year();

  // Convert the UTC moment into the user's timezone
  const momentValue = I18n.moment({
    date: momentDay,
    month: momentMonth,
    year: momentYear
  });
  const momentNow = I18n.moment().startOf('date');

  // For date properties both value and now are at midnight. Relative time will always be `a few seconds ago`
  // So, we confirm the date and return `Today` instead of `a few seconds ago`
  if (isDate && momentNow.date() === momentDay && momentNow.month() === momentMonth && momentNow.year() === momentYear) {
    return 'Today';
  }
  return momentValue.from(momentNow);
};